var _circle, _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 86,
    viewBox: "0 0 91 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.9334,
    cy: 42.9802,
    r: 32.5603,
    fill: "#7F3BEC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3359_108251)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.6772,
    height: 41.6772,
    transform: "translate(24.0947 22.1416)",
    fill: "#7F3BEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.089 42.9801C57.089 43.9391 56.3116 44.7166 55.3525 44.7166H48.6697C47.5652 44.7166 46.6697 45.612 46.6697 46.7166V53.3994C46.6697 54.3584 45.8923 55.1359 44.9332 55.1359C43.9741 55.1359 43.1966 54.3584 43.1966 53.3994V46.7166C43.1966 45.612 42.3012 44.7166 41.1966 44.7166H34.5139C33.5548 44.7166 32.7773 43.9391 32.7773 42.9801C32.7773 42.021 33.5548 41.2435 34.5139 41.2435H41.1966C42.3012 41.2435 43.1966 40.3481 43.1966 39.2435V32.5608C43.1966 31.6017 43.9741 30.8242 44.9332 30.8242C45.8923 30.8242 46.6697 31.6017 46.6697 32.5608V39.2435C46.6697 40.3481 47.5652 41.2435 48.6697 41.2435H55.3525C56.3116 41.2435 57.089 42.021 57.089 42.9801Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.4807 -0.00019896L77.9458 6.5395L84.4885 10.0076L77.9457 13.4758L74.4776 20.0186L71.0094 13.4758L64.4697 10.0107L71.0125 6.54258L74.4807 -0.00019896Z",
    fill: "#7F3BEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1824 27.8333L86.4627 25.8624L84.49 22.1409L82.5174 25.8624L78.796 27.835L82.5174 29.8077L84.4883 33.5273L86.4609 29.8059L90.1824 27.8333Z",
    fill: "#7F3BEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48588 81.7358L5.71367 80.2669L4.2435 77.4934L2.77333 80.2669L-0.000191467 81.7371L2.77332 83.2073L4.24219 85.9795L5.71236 83.206L8.48588 81.7358Z",
    fill: "#7F3BEC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3359_108251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.6772,
    height: 41.6772,
    fill: "white",
    transform: "translate(24.0947 22.1416)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.fdd853f24eb126c4b6fd50e40757e249.svg";
export { ForwardRef as ReactComponent };